import Dialog from '@material-ui/core/Dialog';
import { styled } from '@material-ui/styles';

const BaseDialog = styled(Dialog)((/*{ theme }*/) => ({
  '& .MuiPaper-root': {
    backgroundColor: '#283447'
  }
}));

export { BaseDialog };